import { ChangeDetectionStrategy, Component, TemplateRef, viewChild } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import type { NzNotificationComponent } from 'ng-zorro-antd/notification';
import { HTTP_MESSAGES } from '../i18n/http.messages';

/** Contexto del `nzButton` de NG-ZORRO: la propia notificación (`close()`). */
export interface NoticeContext {
  $implicit: NzNotificationComponent;
}

/**
 * Plantillas de las notificaciones de error: un botón «Cerrar» de verdad (`<button>`, activable con Enter/Espacio).
 * NG-ZORRO cierra con un `<a tabindex="0">` sin `href` (no responde al teclado y se llama «close»), que se oculta en
 * las notificaciones con la clase `ae-notice`. `ApiNotificationsService` crea este componente una vez, fuera del DOM.
 */
@Component({
  selector: 'ae-notification-templates',
  imports: [NzButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ng-template #close let-notice>
      <button
        nz-button
        nzType="default"
        nzSize="small"
        type="button"
        class="ae-notice__close"
        (click)="notice.close()"
        data-testid="notice-close"
      >
        {{ label }}
      </button>
    </ng-template>
  `,
})
export class NotificationTemplatesComponent {
  readonly close = viewChild.required<TemplateRef<NoticeContext>>('close');
  protected readonly label = HTTP_MESSAGES.close;
}
